export const transformDateTime = (dateTimeString: string) => {
  // Parse the date without adding 'Z' to treat it as local time
  // or if it's actually UTC, you can add 'Z' but then convert to local time
  const date = new Date(dateTimeString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffInMinutes = Math.floor(diffMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMinutes / 60);

  // Helper function to format time (e.g., 10:00 PM)
  const formatTime = (date: Date) => {
    const hours = date?.getHours();
    const minutes = date?.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  };

  // Helper function to format date (e.g., dd/mm/yyyy)
  const formatDate = (date: Date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Returns whether the passed date is on the same day as now.
  const isSameDay = (date: Date, now: Date): boolean =>
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  // Check if the date is yesterday
  const isYesterday = (date: Date, now: Date): boolean => {
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
  };

  // Check if the date is within the last week (but not today or yesterday)
  const isLastWeek = (date: Date, now: Date): boolean => {
    const oneWeekAgo = new Date(now);
    oneWeekAgo.setDate(now.getDate() - 7);
    return date < now && date >= oneWeekAgo;
  };

  // Determine which string to return based on the elapsed time
  if (diffInMinutes < 1) {
    return 'Just now';
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
  } else if (isSameDay(date, now)) {
    return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
  } else if (isYesterday(date, now)) {
    return 'Yesterday';
  } else if (isLastWeek(date, now)) {
    return 'Last week';
  } else {
    return `${formatDate(date)}, ${formatTime(date)}`;
  }
};